import { put, call, fork, race, take, select, cancel } from "redux-saga/effects";
import { api } from "../services/index";
import * as auth from "./../actions/auth";
import { getAuthCredentials, getUserContext } from "./../reducers/selectors";

const LoginResult = {
  Success: 0,
  InvalidUser: 1,
  InvalidPassword: 2,
  InvalidUserOrPassword: 3,
  NotAuthorized: 4,
  Fail: 5,
};

const getAuthStatus = () => {
  return sessionStorage.getItem("authenticated") == "true" ? true : false;
};

export const setUserContext = (context) => {
  sessionStorage.setItem("context", JSON.stringify(context));
};

export const setAuthStatus = (status) => {
  if (status == false) {
    setUserContext({});
  }

  sessionStorage.setItem("authenticated", status.toString());
};

function* authFlowSaga() {
  let isAuthenticated = yield call(getAuthStatus);

  let authenticatedTasks;

  if (isAuthenticated) {
    const userContext = getUserContext();

    yield put(auth.authSuccess());
    yield put({ type: "server/authenticate", payload: { token: userContext.accessToken } });
  }

  while (true) {
    if (!isAuthenticated) {
      const result = yield take(auth.SIGN_IN);
      let credentials = yield select((state) => getAuthCredentials(state));

      let { isLoginOk, userContext } = yield call(authorize, credentials);

      if (isLoginOk) {
        isAuthenticated = true;

        yield call(setAuthStatus, true);
        yield call(setUserContext, userContext);
        yield put(auth.authSuccess());
        yield put({ type: "server/authenticate", payload: { token: userContext.accessToken } });
      } else {
        isAuthenticated = false;
      }

      if (!isAuthenticated) continue;
    }

    let userSignedOut;
    while (!userSignedOut) {
      yield take(auth.SIGN_OUT);
      userSignedOut = true;
      isAuthenticated = false;
      yield call(signout);
    }
  }
}

function* authorize(credentialsOrToken) {
  const { response } = yield race({
    response: call(api.authService, credentialsOrToken),
    signout: take(auth.SIGN_OUT),
  });
  const _response = response.response;
  if (_response) {
    if (_response.result == LoginResult.Success) {
      return {
        isLoginOk: true,
        userContext: {
          accessToken: _response.accessToken,
          session: _response.session,
          timezoneOffset: _response.timezoneOffset,
        },
      };
    } else {
      yield put(auth.authFailure(_response.error));

      return {
        isLoginOk: false,
      };
    }
  } else {
    return {
      isLoginOk: false,
    };
  }
}

function* signout() {
  yield call(api.logoutService);
  yield call(setAuthStatus, false);
  yield put(auth.signOut());

  window.API_TOKEN = null;
}

export default authFlowSaga;
